import { render, staticRenderFns } from "./DomainCard.vue?vue&type=template&id=39143d70&scoped=true&"
import script from "./DomainCard.vue?vue&type=script&lang=js&"
export * from "./DomainCard.vue?vue&type=script&lang=js&"
import style0 from "./DomainCard.vue?vue&type=style&index=0&id=39143d70&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39143d70",
  null
  
)

export default component.exports